export default __webpack_public_path__ + "static/media/cp_geo_st.02a19c7f.svg";